import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { MapLocation } from './map-picker.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-map-picker-modal',
    templateUrl: './map-picker-modal.component.html',
    styleUrls: ['./map-picker-modal.component.css']
})
export class MapPickerModalComponent implements OnInit {

    @Input()
    location?: MapLocation;
    @Output()
    locationChange = new EventEmitter<MapLocation>();

    @Input()
    set lat(lat: number | string) {
        if (typeof lat === 'string') lat = parseFloat(lat);
        if (lat) {
            this.location = {...this.location, lat};
        } else {
            this.location = undefined;
        }
    }

    @Input()
    set lon(lon: number | string) {
        if (typeof lon === 'string') lon = parseFloat(lon);
        if (lon) {
            this.location = {...this.location, lng: lon};
        } else {
            this.location = undefined;
        }
    }

    @Output()
    latChange = new EventEmitter<number>();
    @Output()
    lonChange = new EventEmitter<number>();

    mapView?: MapLocation;
    originalLocation?: MapLocation;

    zoomLevel: number;

    isShown = false;
    @ViewChild(ModalDirective, {static: false}) modal: ModalDirective;

    constructor() {
    }

    ngOnInit() {
    }

    show() {
        this.originalLocation = this.location;
        this.mapView = {...this.location};
        this.zoomLevel = this.location ? 12 : 2;
        this.modal.show();
    }

    setMapViewToLocation() {
        this.mapView = {...this.location};
    }

    update() {
        this.modal.hide();
        if (this.location.lat) {
            //clip to 6 decimal places
            this.location.lat = +this.location.lat.toFixed(8);
        }
        if (this.location.lng) {
            this.location.lng = +this.location.lng.toFixed(8);
        }
        this.locationChange.emit(this.location);
        this.latChange.emit(this.location ? this.location.lat : undefined);
        this.lonChange.emit(this.location ? this.location.lng : undefined);
        this.originalLocation = undefined;
    }

    cancel() {
        this.modal.hide();
        this.location = this.originalLocation;
        this.originalLocation = undefined;
    }
}
